var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcInfo = function SvgIcInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.501 14.333a6.333 6.333 0 1 0 0-12.666 6.333 6.333 0 0 0 0 12.666m1-9.8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 1.713c.368 0 .667.299.667.667v5a.667.667 0 0 1-1.333 0v-5c0-.368.298-.667.666-.667",
    clipRule: "evenodd"
  })));
};
export default SvgIcInfo;